import { SectionsTreeNode } from '../types';

/**
 * Finds the top-level TreeNode containing `targetId`, or the node itself if it is already
 * top-level. Returns undefined when the id is not in the tree.
 */
export const findTopLevelTreeNodeByNodeId = (
  nodes: SectionsTreeNode[],
  targetId: string,
): SectionsTreeNode | undefined => {
  for (const node of nodes) {
    if (node.id === targetId) {
      return node; // Finding an element at the highest (top) level
    }

    if (node.children) {
      const foundInChildren = findTopLevelAncestorRecursive(node, targetId);
      if (foundInChildren) {
        return foundInChildren;
      }
    }
  }
  return undefined; // Id not found at the highest (top) level
};

/** Returns `parentNode` if `targetId` is anywhere among its descendants, else undefined. */
const findTopLevelAncestorRecursive = (
  parentNode: SectionsTreeNode,
  targetId: string,
): SectionsTreeNode | undefined => {
  if (parentNode.children) {
    for (const child of parentNode.children) {
      if (child.id === targetId) {
        return parentNode; // Finding the parent element at the highest (top) level
      }
      const foundInGrandchildren = findTopLevelAncestorRecursive(child, targetId);
      if (foundInGrandchildren) {
        return foundInGrandchildren;
      }
    }
  }
  return undefined;
};
